import { render, staticRenderFns } from "./launcher.vue?vue&type=template&id=651e65fc&scoped=true&lang=pug&"
import script from "./launcher.vue?vue&type=script&setup=true&lang=js&"
export * from "./launcher.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./launcher.vue?vue&type=style&index=0&id=651e65fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651e65fc",
  null
  
)

export default component.exports